/**
 * Shared labels and tooltips for procedure economics columns (Admin
 * Procedure Database + Collaboration Analytics ROI tab).
 */

export const PROCEDURE_FIELD_DEFS = {
  reimb: {
    shortLabel: 'Reimb',
    fullLabel: 'Reimbursement',
    tooltip:
      'Published national hospital facility payment benchmark. Medicare values come from CMS IPPS / OPPS / APC references; Private values are modeled from procedure-specific commercial-to-Medicare multipliers.',
  },
  marginPct: {
    shortLabel: 'Margin %',
    fullLabel: 'Contribution margin %',
    tooltip:
      'Contribution margin as a percent of reimbursement: (Reimbursement − direct cost) ÷ Reimbursement. Direct costs are variable costs tied to the case (implants, blood, supplies) — not full hospital overhead.',
  },
  cm: {
    shortLabel: 'CM/Case',
    fullLabel: 'Contribution margin per case',
    tooltip:
      'Hospital contribution margin for the index procedure: reimbursement minus direct/variable costs. This is not operating profit or net income — fixed overhead and indirect costs are excluded.',
  },
  directLtv: {
    shortLabel: 'Direct LTV',
    fullLabel: 'Direct lifetime value',
    tooltip:
      'Modeled downstream contribution margin over ~24 months within the same clinical pathway after the index case (follow-up visits, imaging, device checks, repeat interventions, rehab, readmissions). Excludes the index-case CM.',
  },
  halo: {
    shortLabel: 'Halo',
    fullLabel: 'Halo',
    tooltip:
      'Modeled adjacent-service-line contribution margin from retaining the patient inside the hospital ecosystem (ICU, imaging, pharmacy, wound care, chronic disease management, etc.).',
  },
  total: {
    shortLabel: 'Total',
    fullLabel: 'Total value',
    tooltip:
      'CM/Case + Direct LTV + Halo — the full modeled economic value of winning the referral, stored as an authoritative number per payer.',
  },
  pmRatio: {
    shortLabel: 'P/M Ratio',
    fullLabel: 'Private-to-Medicare ratio',
    tooltip:
      'Avg Private Reimbursement ÷ Avg Medicare Reimbursement. Used with the same-direct-cost assumption to model private CM/Case.',
  },
};

/** Table header with hover tooltip via native title + dotted underline. */
export function FieldHeader({ fieldId, className = '' }) {
  const def = PROCEDURE_FIELD_DEFS[fieldId];
  if (!def) return null;
  return (
    <abbr title={def.tooltip} className={`proc-field-abbr ${className}`.trim()}>
      {def.shortLabel}
    </abbr>
  );
}
